export const REFRESH_SECRET = 'HA662yqIF06Czf6wyrisvhA9zJpsEQFW';
export const HASURA_SECRET = process.env.NEXT_PUBLIC_HASURA_SECRET;
export const GRAPHQL_URL = process.env.NEXT_PUBLIC_GRAPHQL_URL;
export const AUTH_URL = process.env.NEXT_PUBLIC_AUTH_URL;
export const API_APP_URL = process.env.NEXT_PUBLIC_API_APP_URL;
